import { Paper, styled } from '@mui/material';

const RootContainer = styled('div')(() => ({
  width: '100%',
}));

const PaperStyled = styled(Paper)(() => ({
  width: '100%',
  overflow: 'hidden',
  boxShadow: 'none !important' as any,
  border: 'none',
}));

export { RootContainer, PaperStyled };
